module.exports = __webpack_public_path__ + "img/bg_theme0001.871c33c3.jpg";